import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { Box, Typography } from "@material-ui/core";
import { useSelectedTheme, useTranslate } from "../../../../../../Hooks";
import { CustomButton, NoDataFound } from "../../../../../../Components";
import {
  ChevronDownDoubleIcon,
  Image01Icon,
  VideoCreatorIcon,
} from "../../../../../../assets/icons";
import {
  GetAllPropertyImageLocationCategoryByPropertyId,
  GetAllPropertyVideosLocationCategoryByPropertyId,
} from "../../../../../../Services";
import { SectionLocationGalleryList, SectionPropertyGalleryList } from "./UI";

//  styles
import useStyles from "./styles";

// icons
import ChevronUpDoubleIcon from "../../../../../../assets/icons/ChevronUpDoubleIcon";

const Gallery = forwardRef(
  (
    {
      propretyId,
      allPropertyImages,
      allPropertyVideo,
      isLoading,
      setRefetchDataPropertyImage,
      setRefetchDataPropertyVideo,
    },
    ref
  ) => {
    const styles = useStyles();
    const { translate } = useTranslate("NewPropertiesView");
    const {
      theme: { palette },
    } = useSelectedTheme();
    const propertySectionRef = useRef(null);
    const locationSectionRef = useRef(null);
    const [allLocationVedio, setAllLocationVedio] = useState([]);
    const [allLocationImages, setAllLocationImages] = useState([]);

    const navigateLocationSection = () => {
      const el = locationSectionRef?.current;
      if (el) el.scrollIntoView({ behavior: "smooth" });
    };

    const navigatePropretySection = () => {
      const el = propertySectionRef?.current;
      if (el) el.scrollIntoView({ behavior: "smooth" });
    };

    const GetAllPropertyVideoLocationCategory = useCallback(
      async (propertyId) => {
        const result = await GetAllPropertyVideosLocationCategoryByPropertyId(
          propertyId
        );

        if (!(result && result.status && result.status !== 200))
          setAllLocationVedio(result || []);
        else setAllLocationVedio([]);
      },
      []
    );

    const GetAllLocationImages = useCallback(async () => {
      const response = await GetAllPropertyImageLocationCategoryByPropertyId(
        propretyId
      );
      setAllLocationImages(response);
    }, [propretyId]);

    const uploadGallery = () => {};

    useImperativeHandle(ref, () => ({
      uploadGallery,
    }));

    const isAllEmpty =
      (!Array.isArray(allPropertyImages) || allPropertyImages.length === 0) &&
      (!Array.isArray(allPropertyVideo) || allPropertyVideo.length === 0) &&
      (!Array.isArray(allLocationImages) || allLocationImages.length === 0) &&
      (!Array.isArray(allLocationVedio) || allLocationVedio.length === 0);

    useEffect(() => {
      GetAllPropertyVideoLocationCategory(propretyId);
      GetAllLocationImages();
    }, [GetAllPropertyVideoLocationCategory, GetAllLocationImages, propretyId]);

    return (
      <Box className={styles.wrapperGallery}>
        {isLoading ? (
          <></>
        ) : isAllEmpty ? (
          <NoDataFound title="Gallery" />
        ) : (
          <>
            {(allPropertyVideo.length > 0 || allPropertyImages.length > 0) && (
              <Box
                ref={propertySectionRef}
                className={styles.containerPropretiesSection}
              >
                <Box className={styles.containerHeadersection}>
                  <Box className={styles.containerTitles}>
                    <Typography className={styles.mainTitle}>
                      {translate("Property-categories")}
                    </Typography>
                    <Typography className={styles.subTitle}>
                      {translate(
                        "Below-you-will-be-able-to-find-all-related-images-and-videos-to-this-property-you-may-add-edit-or-delete-any-of-the-uploaded-images"
                      )}
                    </Typography>
                  </Box>
                  {(allLocationVedio.length > 0 ||
                    allLocationImages.length > 0) && (
                    <CustomButton
                      size="sm"
                      variant="text"
                      color="tertiaryColor"
                      style={{ display: "flex", gap: "12px" }}
                      endIcon={
                        <ChevronDownDoubleIcon
                          width="20"
                          height="20"
                          fill={palette.button.primary_bg_hover}
                        />
                      }
                      onClick={navigateLocationSection}
                    >
                      {translate("Location-categories")}
                    </CustomButton>
                  )}
                </Box>
                <SectionPropertyGalleryList
                  sectionList={[
                    {
                      type: "images",
                      icon: (
                        <Image01Icon
                          width="20"
                          height="20"
                          fill={palette.utility.utility_gray_400}
                        />
                      ),
                      title: translate("Property-Images"),
                      data: allPropertyImages,
                    },
                    {
                      type: "videos",
                      icon: (
                        <VideoCreatorIcon
                          width="20"
                          height="20"
                          fill={palette.utility.utility_gray_400}
                        />
                      ),
                      title: translate("Property-Videos"),
                      data: allPropertyVideo,
                    },
                  ].filter(
                    (section) =>
                      Array.isArray(section?.data) && section.data.length > 0
                  )}
                  setRefetchDataPropertyImage={setRefetchDataPropertyImage}
                  setRefetchDataPropertyVideo={setRefetchDataPropertyVideo}
                />
              </Box>
            )}
            {(allLocationVedio.length > 0 || allLocationImages.length > 0) && (
              <Box
                ref={locationSectionRef}
                className={styles.containerLoacationSection}
              >
                <Box className={styles.containerHeadersection}>
                  <Box className={styles.containerTitles}>
                    <Typography className={styles.mainTitle}>
                      {translate("Location-categories")}
                    </Typography>
                    <Typography className={styles.subTitle}>
                      {translate(
                        "Below-you-will-find-all-related-images-and-videos-that-are-related-to-this-propertys-location-which-are-defined-via-the-Locations-main-module"
                      )}
                    </Typography>
                  </Box>
                  {(allPropertyVideo.length > 0 ||
                    allPropertyImages.length > 0) && (
                    <CustomButton
                      size="sm"
                      variant="text"
                      color="tertiaryColor"
                      style={{ display: "flex", gap: "12px" }}
                      endIcon={
                        <ChevronUpDoubleIcon
                          width="20"
                          height="20"
                          fill={palette.button.primary_bg_hover}
                        />
                      }
                      onClick={navigatePropretySection}
                    >
                      {translate("Property-categories")}
                    </CustomButton>
                  )}
                </Box>
                <SectionLocationGalleryList
                  sectionList={[
                    {
                      type: "images",
                      icon: (
                        <Image01Icon
                          width="20"
                          height="20"
                          fill={palette.utility.utility_gray_400}
                        />
                      ),
                      title: translate("Location-Images"),
                      data: allLocationImages,
                    },
                    {
                      type: "videos",
                      icon: (
                        <VideoCreatorIcon
                          width="20"
                          height="20"
                          fill={palette.utility.utility_gray_400}
                        />
                      ),
                      title: translate("Location-Videos"),
                      data: allLocationVedio,
                    },
                  ].filter(
                    (section) =>
                      Array.isArray(section?.data) && section.data.length > 0
                  )}
                />
              </Box>
            )}
          </>
        )}
      </Box>
    );
  }
);

export default Gallery;
